import React from "react";
import Button from "../../components/button/Button";
import RightArrow from "../../icons/right-arrow";
import { navigate } from "gatsby";
import TextCorrection from "../../components/text-correction/text-correction";

const TrustMe = () => {
  return (
    <div className="flex flex-col items-center gap-8 py-32 px-4 text-center">
      <h1>
        Zaufaj{" "}
        <TextCorrection correctedText="mojemu" correctedTextPosition="topRight">
          memu
        </TextCorrection>{" "}
        doświadczeniu
      </h1>
      <p className="max-w-[480px]">
        Masz jakieś pytania, uwagi, propozycje, sugestie?
      </p>
      <Button
        color="blue"
        trailingIcon={<RightArrow />}
        onClick={() => navigate("/contact")}
      >
        Napisz do mnie
      </Button>
    </div>
  );
};

export default TrustMe;
